import styled from 'styled-components';

import { cardStyling } from 'DesignLibrary/utils';

export const ProviderCardContainer = styled.div`
  ${cardStyling}
`;
